import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { addGeofenceRequestDTO } from "src/app/features/geofences-map/models/addGeofences/addGeofenceRequestDTO";
import { addGeofencesRequestDTO } from "src/app/features/geofences-map/models/addGeofences/addGeofencesRequestDTO";

@Injectable({
  providedIn: "root",
})
export class GeofencesAPIService implements IApiBase{
  public Result;
  httpHeaders: HttpHeaders = new HttpHeaders();
  configUrl: string;

  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }


  delete(Guid: string): any {
    console.log("/api/Geofence/Delete?guidGeofence="+Guid);
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/Delete?guidGeofence="+Guid);
  }

  Deactivate(Guid: string): any {
    console.log("/api/Geofence/Deactivate?guidGeofence="+Guid);

    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/Deactivate?guidGeofence="+Guid);
  }

  FullDelete(Guid: string) : any {
    console.log("/api/Geofence/FullDelete?guidGeofence="+Guid);
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/FullDelete?guidGeofence="+Guid);
  }

  deleteGeofence($Guid: string) : any {
    console.log("/api/Geofence/delete/");
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Geofence/Delete",$Guid,{});
    }

  getAllGeofencesGeoJson(): any {
    console.log("/api/Geofence/GetGeoJson/");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/GetGeoJson", {});
  }

  GetFencesCentroidsGeoJson(): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/GetFencesCentroidsGeoJson", {});
  }

  get(guid): any {
    console.log("/api/Geofence/Get/");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/Get?Guid=" + guid,{});
  }

  GetByName(name): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/GetByName?name=" + name,{});
  }

  Insert(request: addGeofenceRequestDTO): any {
    console.log("/api/Geofence/Insert/");
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Geofence/Insert",request,{});
  }

  InsertV2(request: addGeofencesRequestDTO): any {
    console.log("/api/Geofence/InsertV2/");
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Geofence/InsertV2",request,{});
  }

  UnassignIdentifier(guid, identifier): any {
    console.log("/api/Geofence/Get/");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/UnassignIdentifier?guidGeofence=" + guid+"&&identifier="+identifier,{});
  }

  findByIdentifier(identifier): any {
    console.log("/api/Geofences/FindByIdentifier/");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofences/FindByIdentifier?identifier=" + identifier, {} );
  }

  getList(): any {
    console.log("/api/Geofence/GetList/");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/GetList", {});
  }

  getStates(): any {
    console.log("/api/Geofence/GetStates/");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/GetStates", {});
  }

  getMunicipalities(stateId: string): any {
    console.log("/api/Geofence/GetMunicipalities/");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Geofence/GetMunicipalities?stateId=" + stateId, {});
  }
}
